export const DETENTION_ALERT_DAYS_OUT = 5; // inclusive
export const OPEN_GATE_STATUS = 'open';
export const INSTRUCTIONS_UNAVAILABLE_ID = 'no';

export const PARSERS_TIMEOUT_MINUTES = 4;
export const REFRESH_INTERVAL_MS = 30 * 1000;
export const REFRESH_APPOINTMENTS_INTERVAL_MS = 60 * 1000;
export const REFRESH_PICKUP_APPOINTMENTS_INTERVAL_MS = 5 * 1000;
export const REFRESH_PER_DIEM_STATUS_INTERVAL_MS = 15 * 1000;
export const DEFAULT_PAGE_SIZE = 25;
// Be careful when updating this variable, we currently store the container numbers in the URL
export const CONTAINER_SEARCH_LIMIT = 100;
export const DEFAULT_HOUR_MINUTE_DISPLAY = 'HH:mm';
export const DATE_DISPLAY_FORMAT = 'ddd, MMM D';
export const CONTAINER_CELL_WIDTH = 180;
export const PICKUP_CELL_WIDTH = 240;
export const ACTIONS_CELL_WIDTH = 128;
export const ACTIONS_CELL_WIDTH_NO_PERMS = 72;
export const RETURN_CELL_WIDTH = 220;
export const DUAL_RETURNS_CELL_WIDTH = 500;
export const HOLDS_CELL_DEFAULT_WIDTH = 520;
export const HOLDS_CELL_MIN_WIDTH = 216;
